import React from 'react'
import { PostsSliderSkeleton } from 'components/Skeletons'
import SectionBlock from 'components/SectionBlock'

const BlogSkeleton = ({ title = 'ბლოგი' }) => {
  return (
    <SectionBlock title={title}>
      <PostsSliderSkeleton />
    </SectionBlock>
  )
}

export default BlogSkeleton
